<template>
  <!-- <div class="row justify-left full-width no-wrap text-filter-item"> -->
  <q-btn
    class="q-my-none"
    flat
    dense
    round
    icon="add"
    size="sm"
    color="grey-8"
    @click="() => {}"
    :aria-label="$t('add_filter')"
  />
  <div class="minw-element-element">{{ getElementName }}</div>
  <!-- </div> -->
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import { SelectionTextFilterSend } from "@/models/interfaces/entity-settings/filters/filters";

@Component({
  name: "AttachmentItemElement",
})
export default class AttachmentItemElement extends Vue {
  @Prop({ default: {} as SelectionTextFilterSend })
  element!: SelectionTextFilterSend;

  @Prop({ default: false })
  isRoot!: boolean;

  @Prop({ default: undefined })
  parentId!: number | undefined;
  @Prop({ default: undefined })
  parentIdx!: string | undefined;
  @Prop({ default: "" })
  parentName!: string;
  @Prop({ default: -1 })
  inputIndex!: number;

  // temporary data
  tempName: string = "";

  created() {
    //
  }

  get getElementName(): string {
    return this.element.Value;
  }

  @Watch("inputItems", { deep: true })
  updateItems() {
    // remember state
    // @ts-ignore
  }
}
</script>

<style lang="scss">
.minw-element-element {
  font-size: 13px !important;
}

.text-filter-item {
  &--child {
    margin-left: 26px !important;
  }
}
</style>
